import { clearHours } from '../util'

export default {
  name: 'PanelTable',
  props: {
    tableDate: {
      type: Date,
      required: true,
    },
    disabledDate: {
      type: Function,
    },
    selectionMode: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    rangeState: {
      type: Object,
      default: () => ({
        from: null,
        to: null,
        selecting: false,
      }),
    },
    focusedDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {
      week: [],
      weekRangeSelectCache: null,
    }
  },
  computed: {
    dates() {
      const { selectionMode, value, rangeState } = this
      const rangeSelecting = selectionMode === 'range' && rangeState.selecting
      let dates = rangeSelecting ? [rangeState.from] : value
      if (this.isWeek && this.isRange && rangeSelecting) {
        if (!this.weekRangeSelectCache) {
          this.weekRangeSelectCache = [rangeState.from]
        } else {
          dates = this.weekRangeSelectCache
        }
      }
      if (!rangeSelecting) {
        this.weekRangeSelectCache = null
      }
      return dates
    },
    isWeek() {
      return /week/.test(this.type)
    },
    isRange() {
      return /range/.test(this.type)
    },
  },
  methods: {
    handleClick(cell) {
      let newDate = new Date(clearHours(cell.date))
      console.log('selected ', newDate)
      this.$emit('on-pick', newDate)
      this.$emit('on-pick-click')
    },
    handleMouseMove(cell) {
      if (this.isWeek) {
        const currentWeek = cell.week
        this.week = this.cells.filter(
          e => e.type !== 'weekLabel' && e.week === currentWeek
        )
        this.$emit('on-week-select', [
          this.week[0].date,
          this.week[this.week.length - 1].date,
        ])
        return
      }
      if (this.type === 'montharea' && this.rangeState.selecting) {
        const dat = new Date(clearHours(cell.date))
        this.$emit('on-month-range-select', dat)
      }
      if (!this.rangeState.selecting) return
      if (cell.disabled) return
      const newDate = cell.date
      this.$emit('on-change-range', newDate)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/date-picker/base/mixin.js